import styled from "styled-components";
import { primaryColor } from "../../config/constants";
import { Link } from "react-router-dom";

export const Title = styled.h2`
  margin: 30px 0 20px;
  font-size: 26px;
  text-align: center;
`;
export const CreateDiv = styled.div`
  margin: 10px auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const CreateLink = styled(Link)`
  margin: 10px auto;
  padding: 10px;
  font-size: 14px;
  color: #000;
  border: 2px solid ${primaryColor};
  outline: none;
  text-decoration: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColor};
    color: #fff;
  }
`;
export const TableHeader = styled.div`
  margin: auto;
  padding: 0 10px;
  width: fit-content;
  display: flex;
`;
export const TableTitle = styled.button`
  padding: 5px 0;
  width: ${({ width }) => (width ? width : "280px")};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background: ${({ isMarked }) => (isMarked ? primaryColor : "transparent")};
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
`;
export const PatientContainer = styled.div`
  margin: 10px auto;
  padding: 15px 10px;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: rgb(0 0 0 / 15%) 0px 5px 15px;
`;
export const PatientField = styled.p`
  width: ${({ width }) => (width ? width : "280px")};
  font-size: 14px;
  text-align: center;
`;
